/* eslint-disable camelcase */
import { ssoAnthConfig } from '@/config/app-config'

const oidcConfig = {
  response_type: 'code',
  post_logout_redirect_uri: '',
  automaticSilentRenew: true,

  includeIdTokenInSilentRenew: true,
  monitorSession: true,
  revokeAccessTokenOnSignout: true,

  ...ssoAnthConfig
}

export default oidcConfig
